const chMessages = {
    "main.name": "姓名",
  "main.sentiment": "情緒",
  "main.urgency": "緊急程度",
  "main.language": "語言",
  "main.agent": "客服專員",
  "main.property_name": "物業名稱",
  "main.booking_number": "預訂編號",
  "main.check_out": "退房",
  "main.check_in": "入住",
  "main.adults": "成人",
  "main.corporate_code": "公司代碼",
  "main.group_code": "團體代碼",
  "main.promo_code": "優惠代碼",
  "main.ai_response": "AI 回覆",
  "main.template_response": "範本回覆",
  "main.converttoticket": "轉換為工單",
  "main.switch_property": "切換物業",
  "main.Group_id": "群組 ID",
  "main.integration_id": "整合 ID",
  "main.submit": "提交",
  "main.cancel": "取消",
    "main.select_template": "選擇範本",
  "main.rooms": "客房",
  "main.rates": "價格",

  //footer
   "footer.knowledge": "知識",
  "footer.home": "主頁",
  "footer.help": "幫助",

  //ticket
  "ticket.thank_you": "感謝您提交表單",
  "ticket.ticket": "工單",
  "ticket.details": "請填寫表單以描述工單詳細資訊。",
  "ticket.select_category": "選擇類別",
  "ticket.category": "類別",
  "ticket.title": "標題",
  "ticket.notes": "備註",
  "ticket.status": "狀態",
  "ticket.assigned_to": "分配給",
  "ticket.submit_form": "提交表單",

  
  "main.total": "總計",
  "main.pastetooutlook": "貼到 Outlook",
  "main.children": "兒童",
  "main.promocode": "優惠/公司/團體代碼",
  "main.exact_match_only": "僅完全匹配",
  "main.search": "搜尋",
  "main.no_rate_match": "沒有符合您選擇的價格。請修改搜尋條件後再試。",
  "main.translate_to": "翻譯至",
  "main.regenerate": "重新生成",
  "main.copy_text": "複製文字",
  "main.additional_instructions": "其他指示",

  "faq.helpcenter": "幫助中心",
  "faq.reply.email.sabre.question": "如何使用 Aven Hospitality Concierge Email Automation 回覆電子郵件？",
  "faq.reply.email.sabre.answer": "開啟電子郵件並啟動 Aven Hospitality 外掛程式。您可以選擇三種方式：使用預設範本、產生 AI 回覆，或將電子郵件轉換為工單。選擇最適合查詢的選項，檢查回覆內容，如有需要進行修改，然後直接從 Outlook 發送。",

  "faq.rates.availability.question": "如何在回覆中新增價格、可用性及房間詳細資料？",
  "faq.rates.availability.answer": "使用 + Rates 功能輸入客人資料，例如日期及入住人數，Concierge 會在回覆中加入準確的房價及可用性。您也可以使用 + Rooms 加入房間描述及圖片。",

  "faq.different.language.question": "如果電子郵件使用不同語言，我該怎麼辦？",
  "faq.different.language.answer": "Aven Hospitality Concierge 可將收到的電子郵件翻譯成您偏好的語言，方便理解。您可以建立或編輯回覆，並在發送前翻譯回客人的語言。",

  "faq.pin.addin.question": "如何確保外掛程式一直可在 Outlook 中使用？",
  "faq.pin.addin.answer": "將 Aven Hospitality Concierge 外掛程式釘選到 Outlook，即可保持顯示並自動開啟。",

  "faq.knowledge.hub.question": "什麼是 Knowledge Hub 搜尋功能？",
  "faq.knowledge.hub.answer": "Knowledge Hub 搜尋功能可讓您直接在 Outlook 中快速查找酒店相關資訊。",

  "faq.reply.email.myma.question": "如何使用 Myma 回覆電子郵件？",
  "faq.reply.email.myma.answer": "開啟電子郵件並啟動 Myma 外掛程式。您可以使用範本、產生 AI 回覆或將電子郵件轉換為工單。",

  "faq.room.details.question": "如何在回覆中新增房間詳細資料？",
  "faq.room.details.answer": "使用 + Rooms 加入房間描述及圖片，幫助客人更了解選項。",

  "faq.myma.different.language.question": "如果電子郵件使用不同語言，我該怎麼辦？",
  "faq.myma.different.language.answer": "Myma 可將收到的電子郵件翻譯成您偏好的語言。",

  "faq.myma.pin.addin.question": "如何確保外掛程式一直可在 Outlook 中使用？",
  "faq.myma.pin.addin.answer": "將 Myma 外掛程式釘選到 Outlook，使其可隨每封電子郵件自動開啟。",

};
export default chMessages;